import { useEffect } from 'react';
import { generatePath } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useRouter from 'app/hooks/useRouter';
import useConfig from 'app/hooks/useConfig';
import useSession from 'app/hooks/useSession';

export default function (step, movieCinemaId) {

  const { adult, child, reduced, packageRegular, packageChild, packageReduced, packageClub } = useSelector(state => state.sessions.wizard);
  const status = useSelector(state => state.payment.status);
  const { history } = useRouter();
  const { routes } = useConfig();
  const session = useSession();
  const prevRoute = history?.location?.state?.prevRoute;

  useEffect(() => {
    if (!status && !(adult || child || reduced || packageRegular || packageChild || packageReduced || packageClub)) {
      if (step < 2 || (step === 2 && !session.getPayment())) {
        session.removeBookingDetails();
        session.removePayment();
        session.removeOrder();

        if (step > 0 && prevRoute !== "reserved") {
          history.push(generatePath(routes.stepTickets.pattern, { movieCinemaId }));
        }
      }
    }
    // eslint-disable-next-line
  }, [status, step, adult, child, reduced, packageRegular, packageChild, packageReduced, packageClub, movieCinemaId, session]);
}
